export default "__VITE_ASSET__BIsDKQMN__"